import { Component, Vue } from "vue-property-decorator";
import { User } from "../../models";
import { camelToUnderscore } from "../../utils/Typography";

@Component
export default class UsersMixin extends Vue {
  readonly path = camelToUnderscore(User.type);
  readonly routes = this.$getModelRoutes(this.path);

  getUsers(data: any, tag) {
    return this.$httpGet(this.routes.indexUrl(data), tag);
  }

  getUser(id: number, tag) {
    return this.$httpGet(this.routes.getUrl(id), tag, "sales_user.id");
  }

  destroyUser(id, tag) {
    return this.$httpDelete(this.routes.deleteUrl(id), tag, null);
  }

  createUser(data: any, tag) {
    return this.$httpPost(this.routes.createUrl(), tag, data);
  }

  updateUser(data: any, tag) {
    return this.$httpPut(this.routes.updateUrl(data.id), tag, data);
  }
}
